module.exports = __webpack_public_path__ + "img/asr-logo-01.f58a0c9f.png";